/* Buckle / clasp selector — HEllO EDC

   Injects Type / Colour / Finish controls, a live preview image, the price
   and a Done button into the theme's existing "Buckle/Clasp Type" drawer.

   Closing is left to the theme (overlay tap, outside tap, handle, close icon,
   Escape) plus our own Done button and a swipe from the drawer's top edge.

   Nothing loads until the shopper opens that drawer. No timers, no polling. */

(function () {
  var cfg = null;
  var hideOOS = false;
  var closeTimer = null;
  var state = {
    selectedId: null, extras: {}, loaded: false, loading: null,
    fallback: false, touched: false, confirmed: false
  };

  /* ---------- helpers ---------- */

  function toInt(t) {
    var m = String(t == null ? '' : t).match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }

  function money(cents) {
    var f = (cfg && cfg.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    if (f.indexOf('amount_no_decimals') > -1) v = Math.round(cents / 100).toString();
    var sym = (f.match(/^[^{]*/) || [''])[0].replace(/&[^;]+;/g, '').trim();
    return (sym || '$') + v;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function setText(el, txt) {
    if (el && el.textContent !== txt) el.textContent = txt;
  }

  /* Rebuild a list ONLY when its contents change. Comparing against live
     innerHTML would be wrong: selection is a class toggle, so the DOM legally
     differs from the freshly-built string, and rebuilding would detach the
     node the shopper just tapped — which the theme reads as a tap outside
     the drawer and closes it. */
  function setList(el, sig, html) {
    if (!el || el.getAttribute('data-wc-sig') === sig) return;
    el.setAttribute('data-wc-sig', sig);
    el.innerHTML = html;
  }

  function thumb(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* Two CDN urls for the same file differ only by their query string. */
  function samePhoto(a, b) {
    return String(a || '').split('?')[0] === String(b || '').split('?')[0];
  }

  /* Which photographs belong to one finish + colour.

     The uploads are labelled "<Title> — <Finish> <Colour> — <n>", so the alt
     text is the only thing that ties a shot to a colourway. The match is on
     the exact "<finish> <colour>" phrase with a non-letter either side, not on
     the two words appearing anywhere: a loose search for "gold" also matches
     "rose gold", which would quietly show gold photographs on the rose gold
     buckle the moment that photography arrives.

     An empty result on a labelled product means this colourway has no
     photography yet. That returns nothing, and the caller hides the preview —
     showing some other colour's photograph is worse than showing none, which
     is exactly what the old cover-image fallback did. Only a product with no
     alt text anywhere falls back to its whole set, because there nothing can
     be told apart. */
  function pickShots(shots, finish, colour) {
    var f = String(finish || '').trim();
    var c = String(colour || '').trim();
    if (!f && !c) return shots.slice();

    var rxEsc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
    var phrase = [f, c].filter(Boolean).map(rxEsc).join('\\s+');
    var re = new RegExp('(^|[^a-z])' + phrase + '([^a-z]|$)', 'i');

    var hit = shots.filter(function (s) { return re.test(s.alt || ''); });
    if (hit.length) return hit;

    var labelled = shots.some(function (s) { return !!(s.alt || '').trim(); });
    return labelled ? [] : shots.slice();
  }

  function specFor(title, finish, colour) {
    var tail = /clasp/i.test(title) ? 'butterfly clasp with spring action opening.'
      : /slim/i.test(title) ? 'Slim design buckle.'
      : /rockstar/i.test(title) ? 'made for refined style.'
      : 'in IWC style design.';
    var plated = colour && colour.toLowerCase() !== 'silver' ? 'PVD ' + colour + ' ' : '';
    return '316L stainless steel, ' + plated + (finish || '').toLowerCase() + ' finish ' + tail;
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getProduct(handle) {
    return fetch(rootUrl() + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* The wording the shopper sees for a chosen buckle, used in the note under
     the buy buttons and on the option button itself. */
  function describe(cur) {
    if (!cur) return '';
    return cur.fam.title +
      (cur.v.colour ? ' · ' + cur.v.colour : '') +
      (cur.v.finish ? ' · ' + cur.v.finish : '');
  }

  /* ---------- finding the drawer to live in ----------

     The theme only builds its dedicated .clasp-type-grid container when the
     option is named exactly "Clasp Type", "Buckle/Clasp Type" or
     "Buckle + Connector". THE F1 APEX names its option "Clasp type" — a
     lowercase t — so it falls through to the theme's generic branch, which
     renders .sizing-guide-options instead and left the selector with nothing
     to mount into.

     Rather than edit the shared variant picker for a capitalisation, the
     accordion is found by id or by its heading, and whatever content box it
     turns out to have is adopted as the grid. */
  function claspAccordion() {
    var acc = document.querySelector('#variant-accordion-clasp-type');
    if (acc) return acc;

    var all = document.querySelectorAll('details.variant-accordion');
    for (var i = 0; i < all.length; i++) {
      var h = all[i].querySelector('.accordion__title');
      if (h && /clasp|buckle/i.test(h.textContent)) return all[i];
    }
    return null;
  }

  function findGrid() {
    var acc = claspAccordion();
    if (!acc) return null;

    var grid = acc.querySelector('.clasp-type-grid');
    if (grid) return grid;

    var content = acc.querySelector('.accordion__content') || acc;
    var host = content.querySelector('.sizing-guide-options') || content.firstElementChild;
    if (!host) return null;

    host.classList.add('clasp-type-grid');
    return host;
  }

  /* ---------- fit ---------- */

  function lugWidth() {
    var checked = document.querySelectorAll('variant-selects input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) {
      var n = (checked[i].name || '').toLowerCase();
      if (n.indexOf('lug') > -1 || n.indexOf('size') > -1 || n.indexOf('watch') > -1) {
        var v = toInt(checked[i].value);
        if (v) return v;
      }
    }
    return null;
  }

  function taper() {
    var lug = lugWidth();
    if (lug == null || !cfg) return null;
    var t = cfg.taper[String(lug)];
    return t == null ? null : t;
  }

  /* ---------- data ---------- */

  /* First paint uses the default buckle's variants inlined by Liquid, so the
     drawer is never empty. The fetch that follows adds imagery and the rest
     of the families. */
  function seedDefault() {
    cfg.families.forEach(function (fam) {
      fam.variants = null;
      fam.spares = null;
      fam.shots = null;
      if (fam.handle === cfg.defaultHandle) {
        fam.variants = (cfg.defaultVariants || []).map(function (v) {
          var w = toInt(v.width) || 0;
          return {
            id: v.id, finish: v.finish, colour: v.colour, width: w, fits: w,
            price: v.price, available: v.available, image: '',
            spec: specFor(fam.title, v.finish, v.colour), spareId: 0, sparePrice: 0
          };
        });
      }
    });
  }

  function loadAll() {
    if (state.loaded) return Promise.resolve();
    if (state.loading) return state.loading;

    var jobs = [];
    cfg.families.forEach(function (fam) {
      jobs.push(getProduct(fam.handle).then(function (p) {
        if (!p) return;
        var cover = p.featured_image || (p.images && p.images[0]) || '';
        fam.image = cover;

        /* Every photo on the product, kept with its alt text. The enlarged
           view is a carousel over these; the alt is what lets a shot be tied
           back to one finish + colour. `media` carries alt text, `images`
           does not — so media is preferred and images is only a fallback for
           products whose media list comes back empty. */
        fam.shots = (p.media || [])
          .filter(function (m) { return m && m.media_type === 'image' && m.src; })
          .map(function (m) { return { src: m.src, alt: m.alt || '' }; });
        if (!fam.shots.length) {
          fam.shots = (p.images || []).map(function (s) { return { src: s, alt: '' }; });
        }

        fam.variants = (p.variants || []).map(function (v) {
          var w = toInt(v.option3) || 0;
          return {
            id: v.id, finish: v.option1 || '', colour: v.option2 || '',
            width: w, fits: w, price: v.price, available: v.available,
            /* Deliberately NOT falling back to the product cover: no variant
               here carries its own featured image, so that fallback made every
               colourway display the cover — the brushed silver shot. The photo
               is chosen from the alt-labelled media instead, in galleryFor. */
            image: (v.featured_image && v.featured_image.src) || '',
            spec: specFor(fam.title, v.option1, v.option2), spareId: 0, sparePrice: 0
          };
        });
      }));

      if (fam.spareHandle) {
        jobs.push(getProduct(fam.spareHandle).then(function (p) {
          fam.spares = (p && p.variants ? p.variants : []).map(function (v) {
            return {
              key: (v.option1 || '') + '|' + (v.option2 || '') + '|' + (toInt(v.option3) || 0),
              id: v.id, price: v.price
            };
          });
        }));
      }
    });

    state.loading = Promise.all(jobs).then(function () {
      cfg.families.forEach(function (fam) {
        var map = {};
        (fam.spares || []).forEach(function (s) { map[s.key] = s; });
        (fam.variants || []).forEach(function (v) {
          var hit = map[v.finish + '|' + v.colour + '|' + v.width];
          v.spareId = hit ? hit.id : 0;
          v.sparePrice = hit ? hit.price : 0;
        });
      });
      state.loaded = true;
      state.loading = null;
    });
    return state.loading;
  }

  /* ---------- model ---------- */

  function families() {
    return cfg.families.filter(function (f) { return f.variants && f.variants.length; });
  }
  function fits(v) { var t = taper(); return t == null || v.fits === t; }
  function usable(v) { return hideOOS ? v.available : true; }

  function compatible() {
    var out = [];
    families().forEach(function (fam) {
      fam.variants.forEach(function (v) { if (fits(v) && usable(v)) out.push({ fam: fam, v: v }); });
    });
    return out;
  }

  function find(id) {
    var hit = null;
    families().forEach(function (fam) {
      fam.variants.forEach(function (v) { if (v.id === id) hit = { fam: fam, v: v }; });
    });
    return hit;
  }

  function pickDefault() {
    var list = compatible();
    var lug = lugWidth();
    var wanted = (lug != null && cfg.overrides[String(lug)]) || cfg.defaultHandle;

    /* The selection is being decided for the shopper rather than by them —
       after a lug-width change, say — so any earlier confirmation no longer
       describes what is now selected. */
    state.confirmed = false;

    /* Cheapest first, but anything in stock beats anything that isn't — a
       default nobody can buy blocks the whole cart, not just the buckle. */
    function best(a, b) {
      if (a.v.available !== b.v.available) return a.v.available ? -1 : 1;
      return a.v.price - b.v.price;
    }

    var pref = list.filter(function (c) { return c.fam.handle === wanted; });
    if (pref.length) {
      pref.sort(best);
      state.selectedId = pref[0].v.id; state.fallback = false; return;
    }
    if (!list.length) { state.selectedId = null; state.fallback = false; return; }
    list.sort(best);
    state.selectedId = list[0].v.id;
    state.fallback = true;
  }

  function ensureSelection() {
    var cur = state.selectedId ? find(state.selectedId) : null;
    if (!cur || !fits(cur.v) || !usable(cur.v)) pickDefault();
  }

  /* ---------- drawer plumbing ---------- */

  function fieldset() {
    var d = claspAccordion();
    return d ? d.closest('fieldset[data-option-index]') : null;
  }

  function closeDrawer() {
    document.querySelectorAll('.mobile-drawer-active').forEach(function (el) {
      el.classList.remove('mobile-drawer-active', 'drawer-expanded');
    });
    document.querySelectorAll('.mobile-variant-drawer-overlay').forEach(function (el) {
      el.classList.remove('is-visible');
    });
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function cancelClose() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  }

  /* ---------- confirming the choice ---------- */

  /* On mobile, Done closes the drawer and that IS the feedback. On desktop the
     panel is inline, so pressing Done would otherwise look like nothing
     happened: the button confirms first, then the panel collapses a beat
     later so the shopper sees the confirmation before it goes.

     The button holds its confirmed state either way — it only returns to
     "Done" if the shopper changes the buckle again, so reopening the panel
     still shows whether what is inside has been confirmed. The note above
     Add to cart carries the same confirmation somewhere permanent. */
  function flashNote() {
    var note = document.querySelector('[data-wc-total]');
    if (!note || note.hidden) return;
    note.classList.remove('wc-total--flash');
    void note.offsetWidth;           // restart the animation
    note.classList.add('wc-total--flash');
  }

  /* A buckle that cannot ship cannot be confirmed. Beyond the obvious — a green
     tick over an out-of-stock part is a lie — Shopify rejects a whole
     /cart/add.js when any line is unavailable, so confirming here would leave
     the shopper unable to buy the strap either. */
  function paintDone() {
    var btn = document.querySelector('[data-wc-done]');
    if (!btn) return;

    var cur = state.selectedId ? find(state.selectedId) : null;
    var ok = !!(cur && cur.v.available);

    btn.disabled = !ok;
    btn.classList.toggle('is-out', !ok);
    setText(btn, !ok ? 'Out of stock' : (state.confirmed ? '✓ Buckle selected' : 'Done'));
    btn.classList.toggle('is-done', ok && state.confirmed);
  }

  /* Stripping the drawer's classes ourselves is not enough. The theme holds
     its own activeDrawerIndex, and while that is set its MutationObserver
     REOPENS the drawer as soon as anything inside product-info changes —
     which is exactly what our own render() just did a moment earlier. The
     drawer closed and sprang straight back, so it took a second press.

     Escape is one of the theme's own documented close paths and it clears
     that state, so we ask for the close rather than fake it. */
  function collapsePanel() {
    try {
      document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Escape', bubbles: true }));
    } catch (e) { /* older browsers — the manual close below still runs */ }

    closeDrawer();

    var acc = claspAccordion();
    if (acc && acc.open) acc.open = false;
  }

  function confirmDone() {
    var cur = state.selectedId ? find(state.selectedId) : null;
    if (!cur || !cur.v.available) return;   // nothing to confirm

    /* Pressing Done is an explicit choice even if the shopper kept the
       default, so the option button may now show the selection. */
    state.touched = true;
    state.confirmed = true;
    render();
    sync();
    flashNote();

    cancelClose();

    /* Mobile: the drawer sliding away is itself the acknowledgement, so it
       goes at once — a delay there just feels unresponsive. */
    if (document.querySelector('.mobile-drawer-active')) {
      collapsePanel();
      return;
    }

    closeTimer = setTimeout(function () {
      closeTimer = null;
      collapsePanel();
    }, 850);
  }

  /* ---------- magnified view ----------

     The drawer is a transformed, clipped container, so a zoom panel inside it
     would be cropped. It lives on <body> instead, above the drawer, and
     swallows its own clicks so the theme doesn't read them as "outside".

     It is a carousel: the shopper can swipe through the other photographs of
     the buckle they have selected without leaving the drawer. Which photos
     belong to which finish and colour is read from the images' alt text —
     the uploads follow "<Title> — <Finish> <Colour> — <n>". Where a product's
     alts are empty the filter can't narrow anything, so every photo of that
     buckle is shown rather than none. */

  function galleryFor(cur) {
    if (!cur) return [];

    var shots = (cur.fam.shots || []).filter(function (s) { return s && s.src; });
    var list = pickShots(shots, cur.v.finish, cur.v.colour);

    /* If this variant ever gets its own featured image in the admin, that is
       the shot the shopper should land on. It is only moved to the front (or
       added) — the product cover is never used, which is what produced the
       repeated first slide and the silver photo on every gold buckle. */
    var own = cur.v.image || '';
    if (own) {
      var at = -1;
      for (var i = 0; i < list.length; i++) {
        if (samePhoto(list[i].src, own)) { at = i; break; }
      }
      if (at > 0) list.unshift(list.splice(at, 1)[0]);
      else if (at < 0) list.unshift({ src: own, alt: '' });
    }
    return list;
  }

  /* The one photo shown on the preview button: the first of the gallery it
     opens, so the two can never disagree. */
  function photoFor(cur) {
    var g = galleryFor(cur);
    return (g[0] && g[0].src) || '';
  }

  function closeZoom() {
    var z = document.querySelector('.wc-zoom');
    if (z) z.parentNode.removeChild(z);
  }

  function openZoom(shots, label) {
    if (!shots || !shots.length) return;
    closeZoom();

    var many = shots.length > 1;
    var at = 0;

    var z = document.createElement('div');
    z.className = 'wc-zoom' + (many ? ' wc-zoom--many' : '');
    z.innerHTML =
      '<figure class="wc-zoom__box">' +
        '<div class="wc-zoom__track" data-wc-track>' +
          shots.map(function (s, i) {
            return '<div class="wc-zoom__slide">' +
              '<img src="' + esc(thumb(s.src, 1400)) + '" alt="' +
              esc(s.alt || label) + '"' + (i ? ' loading="lazy"' : '') + '>' +
            '</div>';
          }).join('') +
        '</div>' +
        (many
          ? '<button type="button" class="wc-zoom__nav wc-zoom__nav--prev" ' +
              'data-wc-step="-1" aria-label="Previous photo">&#8249;</button>' +
            '<button type="button" class="wc-zoom__nav wc-zoom__nav--next" ' +
              'data-wc-step="1" aria-label="Next photo">&#8250;</button>' +
            '<div class="wc-zoom__dots" data-wc-dots>' +
              shots.map(function (s, i) {
                return '<button type="button" class="wc-zoom__dot' + (i ? '' : ' is-on') +
                  '" data-wc-dot="' + i + '" aria-label="Photo ' + (i + 1) +
                  ' of ' + shots.length + '"></button>';
              }).join('') +
            '</div>'
          : '') +
        '<figcaption class="wc-zoom__cap">' + esc(label) + '</figcaption>' +
      '</figure>' +
      '<button type="button" class="wc-zoom__x" data-wc-x aria-label="Close">&times;</button>';

    var track = z.querySelector('[data-wc-track]');

    function paintIndex(i) {
      if (i === at) return;
      at = i;
      z.querySelectorAll('[data-wc-dot]').forEach(function (d) {
        d.classList.toggle('is-on', parseInt(d.getAttribute('data-wc-dot'), 10) === i);
      });
    }

    function goTo(i, smooth) {
      if (!track) return;
      i = Math.max(0, Math.min(shots.length - 1, i));
      var w = track.clientWidth || 1;
      if (track.scrollTo) track.scrollTo({ left: i * w, behavior: smooth === false ? 'auto' : 'smooth' });
      else track.scrollLeft = i * w;
      paintIndex(i);
    }

    /* Only the backdrop and the close button dismiss. A tap or drag on the
       photograph has to stay live or there is nothing to swipe with. */
    z.addEventListener('click', function (e) {
      e.stopPropagation();

      if (e.target.closest('[data-wc-x]')) { closeZoom(); return; }

      var step = e.target.closest('[data-wc-step]');
      if (step) { goTo(at + parseInt(step.getAttribute('data-wc-step'), 10)); return; }

      var dot = e.target.closest('[data-wc-dot]');
      if (dot) { goTo(parseInt(dot.getAttribute('data-wc-dot'), 10)); return; }

      if (!e.target.closest('.wc-zoom__box')) closeZoom();
    });

    if (track && many) {
      var settle = null;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var w = track.clientWidth || 1;
          paintIndex(Math.round(track.scrollLeft / w));
        }, 60);
      }, { passive: true });
    }

    z.addEventListener('keydown', function (e) {
      if (!many) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(at + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(at - 1); }
    });

    document.body.appendChild(z);
    z.setAttribute('tabindex', '-1');
    try { z.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
  }

  /* ---------- price ---------- */

  function selectedVariant() {
    var el = document.querySelector('variant-selects script[data-selected-variant]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* The buckle replaces the stock one, so every price on the page must read as
     the price of the chosen combination — not the strap plus an add-on. */
  function paintPrice() {
    var v = selectedVariant();
    if (!v || typeof v.price !== 'number') return;
    var cur = state.selectedId ? find(state.selectedId) : null;
    var delta = cur ? cur.v.price : 0;
    var total = money(v.price + delta);

    /* main price block */
    var block = document.querySelector('product-info .price');
    if (block) {
      var cmp = typeof v.compare_at_price === 'number' ? v.compare_at_price : 0;
      var onSale = cmp > v.price;
      setText(block.querySelector(
        onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular'
      ), total);
      if (onSale) {
        setText(block.querySelector('.price__sale s.price-item--regular'), money(cmp + delta));
      }
    }

    /* mobile title bar — "PRODUCT NAME | $PRICE" in a single heading */
    document.querySelectorAll('.product-banner-section__title').forEach(function (h) {
      var txt = h.textContent.trim();
      if (!h.getAttribute('data-wc-name')) {
        var i = txt.lastIndexOf('|');
        if (i < 0) { h.setAttribute('data-wc-name', ''); return; }
        h.setAttribute('data-wc-name', txt.slice(0, i).trim());
      }
      var name = h.getAttribute('data-wc-name');
      if (name) setText(h, name + ' | ' + total);
    });

    /* Note above the buy buttons. This is the shopper's standing confirmation
       of which buckle is going into the cart, so it names the buckle whenever
       one is chosen — not only when it costs extra. */
    var note = document.querySelector('[data-wc-total]');
    if (note) {
      var show = !!cur;
      if (note.hidden !== !show) note.hidden = !show;
      if (show) {
        setText(note, '✓ Buckle: ' + describe(cur) +
          (cur.v.price > 0 ? ' (+' + money(cur.v.price) + ')' : ' — included'));
      }
    }
  }

  /* ---------- the option button label ---------- */

  /* Shown only once the shopper has actually chosen — like the theme's other
     option buttons, which stay blank until they are touched. Long selections
     scroll in a loop so the whole thing can be read. */
  function paintButtonLabel(txt) {
    var fs = fieldset();
    if (!fs) return;
    var idx = fs.getAttribute('data-option-index');
    var el = document.querySelector('.mobile-variant-btn__value[data-option-index="' + idx + '"]');
    if (!el || el.getAttribute('data-wc-label') === txt) return;

    /* The theme hides this span until IT marks the button selected, which only
       happens on a native radio click. Our own attribute unhides it via CSS. */
    el.setAttribute('data-wc-label', txt);
    el.classList.remove('wc-marq-on');
    el.textContent = txt;

    requestAnimationFrame(function () {
      if (el.scrollWidth - el.clientWidth <= 2) return;
      el.innerHTML = '<span class="wc-marq"><span class="wc-marq__t">' + esc(txt) + '</span>' +
        '<span class="wc-marq__t" aria-hidden="true">' + esc(txt) + '</span></span>';
      var one = el.querySelector('.wc-marq__t');
      var dist = (one ? one.scrollWidth : el.scrollWidth) + 28;
      el.style.setProperty('--wc-marq-dist', dist + 'px');
      el.style.setProperty('--wc-marq-time', Math.max(5, dist / 28).toFixed(1) + 's');
      el.classList.add('wc-marq-on');
    });
  }

  /* ---------- injection ---------- */

  function mount() {
    var grid = findGrid();
    if (!grid) return;

    if (!grid.querySelector('[data-wc-panel]')) {
      grid.classList.add('wc-taken');
      var panel = document.createElement('div');
      panel.className = 'wc-panel';
      panel.setAttribute('data-wc-panel', '');
      panel.innerHTML =
        '<div class="wc-cols">' +
          '<div class="wc-main">' +
            '<div class="wc-fit" data-wc-fit></div>' +
            '<div class="wc-field"><span class="wc-field__label">Type</span>' +
              '<div class="wc-pills" data-wc-type></div></div>' +
            '<div class="wc-suits" data-wc-suits hidden></div>' +
            '<div class="wc-field"><span class="wc-field__label">Colour</span>' +
              '<div class="wc-swatches" data-wc-colour></div></div>' +
            '<div class="wc-field" data-wc-finish-field><span class="wc-field__label">Finish</span>' +
              '<div class="wc-pills" data-wc-finish></div></div>' +
            '<div class="wc-chosen" data-wc-chosen></div>' +
          '</div>' +
          '<aside class="wc-side">' +
            '<button type="button" class="wc-shot" data-wc-shot hidden ' +
              'aria-label="View this buckle larger"></button>' +
            '<div class="wc-foot">' +
              '<span class="wc-foot__amt" data-wc-amt></span>' +
              '<span class="wc-foot__sub" data-wc-sub></span>' +
              '<button type="button" class="wc-done" data-wc-done>Done</button>' +
            '</div>' +
          '</aside>' +
        '</div>';
      grid.appendChild(panel);

      panel.addEventListener('click', function (e) {
        var shot = e.target.closest('[data-wc-shot]');
        if (shot) {
          var cur = state.selectedId ? find(state.selectedId) : null;
          openZoom(galleryFor(cur), shot.getAttribute('data-wc-alt') || '');
          return;
        }
        var t = e.target.closest('[data-wc-pick-type]');
        if (t) { pickType(t.getAttribute('data-wc-pick-type')); return; }
        var c = e.target.closest('[data-wc-sw]');
        if (c) { applyPart('colour', c.getAttribute('data-wc-sw')); return; }
        var f = e.target.closest('[data-wc-pick-finish]');
        if (f) { applyPart('finish', f.getAttribute('data-wc-pick-finish')); return; }
        if (e.target.closest('[data-wc-done]')) { closeZoom(); confirmDone(); }
      });

      bindSwipe(grid.closest('fieldset[data-option-index]'));
    }

    if (!state.loaded && !state.loading) {
      loadAll().then(function () { ensureSelection(); render(); sync(); });
    }
    render();
  }

  /* Swipe to dismiss — deliberately narrow: the gesture must START in the
     drawer's top strip (the grab-handle area), travel a long way down, and be
     clearly vertical. Anything else is the shopper scrolling the options. */
  function bindSwipe(fs) {
    if (!fs || fs.getAttribute('data-wc-swipe')) return;
    fs.setAttribute('data-wc-swipe', '1');

    var TOP_STRIP = 56;   // px from the drawer's top edge
    var MIN_DROP = 110;   // px of downward travel
    var MAX_DRIFT = 60;   // px of sideways travel allowed

    var y0 = null, x0 = 0;

    fs.addEventListener('touchstart', function (e) {
      y0 = null;
      if (!e.touches || e.touches.length !== 1) return;
      if (fs.scrollTop > 2) return;
      var r = fs.getBoundingClientRect();
      var y = e.touches[0].clientY;
      if (y - r.top > TOP_STRIP) return;
      y0 = y; x0 = e.touches[0].clientX;
    }, { passive: true });

    fs.addEventListener('touchend', function (e) {
      if (y0 == null || !e.changedTouches || !e.changedTouches.length) return;
      var dy = e.changedTouches[0].clientY - y0;
      var dx = Math.abs(e.changedTouches[0].clientX - x0);
      if (dy > MIN_DROP && dx < MAX_DRIFT && fs.scrollTop <= 2) collapsePanel();
      y0 = null;
    }, { passive: true });
  }

  function pickType(handle) {
    cancelClose();   // still choosing — don't collapse underneath them
    var fam = cfg.families.filter(function (f) { return f.handle === handle; })[0];
    if (!fam || !fam.variants) return;
    var opts = fam.variants.filter(function (v) { return fits(v) && usable(v); });
    if (!opts.length) return;

    /* Carry the shopper's colour and finish across where the new type has them. */
    var cur = state.selectedId ? find(state.selectedId) : null;
    var keep = cur ? opts.filter(function (v) {
      return v.colour === cur.v.colour && v.finish === cur.v.finish;
    })[0] || opts.filter(function (v) { return v.colour === cur.v.colour; })[0] : null;

    if (!keep) {
      opts = opts.slice().sort(function (a, b) { return a.price - b.price; });
      keep = opts[0];
    }

    state.selectedId = keep.id;
    state.fallback = false;
    state.touched = true;
    state.confirmed = false;   // a new choice needs confirming again
    render(); sync();
  }

  function applyPart(part, value) {
    cancelClose();   // still choosing — don't collapse underneath them
    var cur = state.selectedId ? find(state.selectedId) : null;
    if (!cur) return;
    var want = { finish: cur.v.finish, colour: cur.v.colour };
    want[part] = value;

    var pool = cur.fam.variants.filter(function (v) { return fits(v) && usable(v); });
    var match = pool.filter(function (v) {
      return v.finish === want.finish && v.colour === want.colour;
    })[0] || pool.filter(function (v) { return v[part] === value; })[0];

    if (match) { state.selectedId = match.id; state.fallback = false; }
    state.touched = true;
    state.confirmed = false;   // a new choice needs confirming again
    render(); sync();
  }

  /* ---------- render ---------- */

  function render() {
    var panel = document.querySelector('[data-wc-panel]');
    if (!panel || !cfg) return;

    ensureSelection();

    var t = taper(), lug = lugWidth();
    setText(panel.querySelector('[data-wc-fit]'),
      lug && t ? 'Lug × Taper — ' + lug + 'mm × ' + t + 'mm'
        : lug ? 'Lug — ' + lug + 'mm' : '');

    var list = compatible();
    var cur = state.selectedId ? find(state.selectedId) : null;

    var famOpts = [], seen = {};
    list.forEach(function (c) {
      if (!seen[c.fam.handle]) { seen[c.fam.handle] = 1; famOpts.push(c.fam); }
    });

    var mine = cur ? cur.fam.variants.filter(function (v) { return fits(v) && usable(v); }) : [];

    var cols = [], cs = {};
    mine.forEach(function (v) { if (v.colour && !cs[v.colour]) { cs[v.colour] = 1; cols.push(v.colour); } });

    var fins = [], fs2 = {};
    mine.forEach(function (v) { if (v.finish && !fs2[v.finish]) { fs2[v.finish] = 1; fins.push(v.finish); } });

    setList(panel.querySelector('[data-wc-type]'),
      famOpts.map(function (f) { return f.handle; }).join('~'),
      famOpts.map(function (f) {
        return '<button type="button" class="wc-pill" data-wc-pick-type="' +
          esc(f.handle) + '">' + esc(f.title) + '</button>';
      }).join(''));

    setList(panel.querySelector('[data-wc-colour]'), cols.join('~'),
      cols.map(function (c) {
        return '<button type="button" class="wc-sw" data-wc-sw="' + esc(c) +
          '"><i class="wc-sw__dot wc-sw__dot--' +
          esc(c.toLowerCase().replace(/\s+/g, '-')) + '"></i><span>' + esc(c) + '</span></button>';
      }).join(''));

    setList(panel.querySelector('[data-wc-finish]'), fins.join('~'),
      fins.map(function (f) {
        return '<button type="button" class="wc-pill" data-wc-pick-finish="' +
          esc(f) + '">' + esc(f) + '</button>';
      }).join(''));

    var finField = panel.querySelector('[data-wc-finish-field]');
    if (finField.hidden !== (fins.length < 2)) finField.hidden = fins.length < 2;

    /* selection state — class toggles only, so nothing is detached mid-tap */
    panel.querySelectorAll('[data-wc-pick-type]').forEach(function (b) {
      b.classList.toggle('is-on', !!cur && b.getAttribute('data-wc-pick-type') === cur.fam.handle);
    });
    panel.querySelectorAll('[data-wc-sw]').forEach(function (b) {
      b.classList.toggle('is-on', !!cur && b.getAttribute('data-wc-sw') === cur.v.colour);
    });
    panel.querySelectorAll('[data-wc-pick-finish]').forEach(function (b) {
      b.classList.toggle('is-on', !!cur && b.getAttribute('data-wc-pick-finish') === cur.v.finish);
    });

    /* preview image — hidden entirely until the buckle photography exists,
       so the rail never shows an empty hole */
    var shot = panel.querySelector('[data-wc-shot]');
    var src = cur ? photoFor(cur) : '';
    var alt = cur ? cur.fam.title + ' · ' + cur.v.colour + ' · ' + cur.v.finish : '';
    var more = cur ? galleryFor(cur).length : 0;
    if (shot.getAttribute('data-wc-src') !== src) {
      shot.setAttribute('data-wc-src', src);
      shot.hidden = !src;
      shot.innerHTML = src
        ? '<img src="' + esc(thumb(src, 400)) + '" alt="' + esc(alt) +
          '" width="400" height="400" loading="lazy" decoding="async">' +
          '<span class="wc-shot__hint" aria-hidden="true">' +
          (more > 1 ? 'Tap to view all ' + more : 'Tap to enlarge') + '</span>'
        : '';
      closeZoom();
    } else if (src) {
      /* The photo is unchanged but the gallery behind it may not be — the
         product fetch lands after the first paint. */
      var hint = shot.querySelector('.wc-shot__hint');
      if (hint) setText(hint, more > 1 ? 'Tap to view all ' + more : 'Tap to enlarge');
    }
    shot.setAttribute('data-wc-alt', alt);

    /* watch-style pairing */
    var suits = panel.querySelector('[data-wc-suits]');
    var pairs = cur && cur.fam.suits && cur.fam.suits.length ? cur.fam.suits.join(' · ') : '';
    if (suits.hidden !== !pairs) suits.hidden = !pairs;
    if (pairs && suits.getAttribute('data-wc-sig') !== pairs) {
      suits.setAttribute('data-wc-sig', pairs);
      suits.innerHTML = '<span class="wc-suits__label">Pairs with</span>' +
        '<span class="wc-suits__list">' + esc(pairs) + '</span>';
    }

    /* spec line */
    var chosen = panel.querySelector('[data-wc-chosen]');
    setText(chosen, cur ? cur.v.spec : 'No buckle fits this size.');
    chosen.classList.toggle('wc-chosen--none', !cur);

    /* rail: the price of this combination */
    var v = selectedVariant();
    setText(panel.querySelector('[data-wc-amt]'),
      !v || typeof v.price !== 'number' ? '' : money(v.price + (cur ? cur.v.price : 0)));
    if (state.confirmed && (!cur || !cur.v.available)) state.confirmed = false;

    setText(panel.querySelector('[data-wc-sub]'), !cur ? ''
      : (cur.v.price > 0 ? 'with this buckle' : 'buckle included')
        + (cur.v.available ? '' : ' · out of stock')
        + (state.fallback ? ' · default unavailable' : ''));

    paintDone();
  }

  /* ---------- outward sync ---------- */

  function sync() {
    var cur = state.selectedId ? find(state.selectedId) : null;

    /* Uppercase to sit alongside the theme's other option values. Only after a
       real choice — a pre-filled default would read as the shopper's own. */
    if (cur && state.touched) {
      paintButtonLabel((cur.fam.title + (cur.v.colour ? ' · ' + cur.v.colour : '')).toUpperCase());
    }

    paintPrice();

    var extras = [];
    Object.keys(state.extras).forEach(function (id) {
      var q = state.extras[id];
      if (!q) return;
      var hit = find(parseInt(id, 10));
      if (hit && hit.v.spareId) extras.push({ id: hit.v.spareId, quantity: q });
    });

    window.WCBuckle = {
      componentVariantId: cur ? cur.v.id : null,
      componentTitle: cur ? cur.fam.title : null,
      componentPrice: cur ? cur.v.price : 0,
      componentAvailable: cur ? !!cur.v.available : null,
      chosenByShopper: state.touched,
      confirmed: state.confirmed,
      extras: extras,
      taper: taper(),
      lug: lugWidth()
    };
    document.dispatchEvent(new CustomEvent('wc-buckle:change', { detail: window.WCBuckle }));
  }

  /* ---------- boot ---------- */

  function boot() {
    var el = document.querySelector('[data-wc-buckle-data]');
    if (!el) return;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    if (!cfg || !cfg.families || !cfg.families.length) return;

    var script = document.querySelector('script[src*="wc-buckle.js"]');
    hideOOS = !!(script && script.dataset.hideOos === 'true');

    /* The extras block under Add to cart shows the same hardware and wants the
       same enlarged view. Exposed rather than copied, so there is one
       implementation of how the viewer behaves. */
    window.WCBuckleZoom = function (title, colour, finish, label) {
      var fam = null;
      for (var i = 0; i < cfg.families.length; i++) {
        if (cfg.families[i].title === title) { fam = cfg.families[i]; break; }
      }
      if (!fam) return;

      var v = (fam.variants || []).filter(function (x) {
        return x.colour === colour && x.finish === finish;
      })[0] || { colour: colour, finish: finish, image: '' };

      openZoom(
        galleryFor({ fam: fam, v: v }),
        label || [title, colour, finish].filter(Boolean).join(' · ')
      );
    };

    seedDefault();
    ensureSelection();
    mount();
    sync();

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeZoom();
    });

    /* The theme replaces the whole fieldset on every variant change. Re-mount
       ONLY when our panel is actually gone — reacting to any mutation would
       loop, because rendering the panel mutates product-info itself. */
    var info = document.querySelector('product-info');
    if (info && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (document.querySelector('[data-wc-panel]')) return;
        if (pending) return;
        pending = setTimeout(function () { pending = null; mount(); sync(); }, 60);
      }).observe(info, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
